import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-access-privileges-requests',
  templateUrl: './access-privileges-requests.component.html',
  styleUrls: ['./access-privileges-requests.component.css']
})
export class AccessPrivilegesRequestsComponent implements OnInit {

  cid: any
  accessPrivilegesRequestsList: any = []
  singleAccessPrivilegesRequestData: any = []

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false


actionControls: any = {
  isAdd: false, 
  isView: false, 
  isDelete: false, 
  isModify: false 
}


  constructor(
    private generic_service: GenericService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {

  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action
    this.cid = sessionStorage.getItem('cid')

    this.getAllAccessPrivilegesRequests();
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getAllAccessPrivilegesRequests()
  }

  getAllAccessPrivilegesRequests(){
    this.isLoading = true
    this.generic_service.getAllAccessPrivilegesRequests().subscribe(
      (response:any)=>{
        console.log(response);
        this.accessPrivilegesRequestsList = response.response
        this.totalRecords = response.response.length
        this.isLoading = false
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  updateAccessPrivilegesRequest(status: any){
    let body = {
      "requestId": Number(this.singleAccessPrivilegesRequestData[0].requestId),
      "status": status,
      "cid": Number(this.cid)
    }
    this.generic_service.updateAccessPrivilegesRequest(body).subscribe(
      (response:any)=>{
        console.log(response);
        document.getElementById("closeModalButton")?.click()
        this.toastr.success('Request ' + status)
        this.getAllAccessPrivilegesRequests();

      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  getAccessPrivilegesRequestByRequestId(requestId: any){
    this.generic_service.getAccessPrivilegesRequestByRequestId(requestId).subscribe(
      (response:any)=>{
        console.log(response);
        this.singleAccessPrivilegesRequestData = []
        this.singleAccessPrivilegesRequestData.push(response.response)
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

}
